<template>
  <div>
    <iframe
      name="iframe_name"
      id="iframe_id"
      :src="payment_url"
      style="width:100%;height:700px;border:0 none;"
      scrolling="no"
      frameborder="0"
    ></iframe>
    <iframe> </iframe>
  </div>
</template>

<script>
import { PAYMENT_URL } from "@/common/config";
import { mapGetters } from "vuex";
export default {
  name: "payment",
  data() {
    return {
      payment_url: PAYMENT_URL + "?id=" + this.$route.params.app_id,
      payemnt_page: { html: null }
    };
  },
  computed: {
    ...mapGetters(["session"])
  }
};
</script>

<style></style>
